import { useState } from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { useDeviceStore } from "../state/deviceStore"
import { useAuthStore } from "../state/authStore"
import { loginWaiter } from "../api/auth"
import { ApiClientError } from "../api/client"
import PinPad from "../components/PinPad"

export default function PinPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { waiterId } = useParams()
  const deviceUuid = useDeviceStore(s => s.deviceUuid)
  const setSession = useAuthStore(s => s.setWaiterSession)

  const state = location.state as { username: string; ime: string; prezime: string } | null
  const [pin, setPin] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handlePinChange = async (newPin: string) => {
    setPin(newPin)
    setError(null)
    if (newPin.length === 4 && state && deviceUuid) {
      setLoading(true)
      try {
        const result = await loginWaiter(deviceUuid, state.username, newPin)
        setSession({
          token: result.sessionToken,
          korisnikId: result.korisnikId,
          ime: result.ime,
          prezime: result.prezime,
          companyId: result.companyId,
          companyName: result.companyName,
          poslovnaJedinicaId: result.poslovnaJedinicaId,
          kasaId: result.kasaId,
          sessionPrinterId: result.sessionPrinterId,
          prava: result.prava
        })
        navigate("/order", { replace: true })
      } catch (err) {
        const msg = err instanceof ApiClientError ? (err.detail || err.message) : "Greška."
        setError(msg)
        setPin("")
      } finally {
        setLoading(false)
      }
    }
  }

  if (!state || !waiterId) return <div className="p-6">Nedostaju podaci.</div>

  return (
    <div className="flex-1 flex flex-col p-6">
      <button onClick={() => navigate("/login")} className="text-slate-500 mb-4 self-start">← Nazad</button>
      <div className="text-center mb-8">
        <div className="w-20 h-20 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-2xl font-bold">
          {state.ime.charAt(0)}{state.prezime.charAt(0)}
        </div>
        <h1 className="text-2xl font-bold text-slate-800">{state.ime} {state.prezime}</h1>
        <p className="text-slate-500 mt-1">Unesi PIN</p>
      </div>
      <div className="flex justify-center gap-3 mb-6">
        {[0,1,2,3].map(i => (
          <div key={i} className={`w-4 h-4 rounded-full ${i < pin.length ? "bg-primary-600" : "bg-slate-300"}`}></div>
        ))}
      </div>
      {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-center mb-4 max-w-xs mx-auto">{error}</div>}
      {loading && <div className="text-center text-slate-500 mb-4">Provjeravam...</div>}
      <PinPad value={pin} onChange={handlePinChange} />
    </div>
  )
}
